import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import routes from "@/routes"
import { useShadcnInsetBreadcrumbContext } from "@/contexts/ShadcnInsetBreadcrumbContext"
import type { RouteConfigArray } from "@/types/routes"
import { getBreadcrumbTrail } from "@/utils/breadcrumbPageTitle"
import { resolveDocumentTitle } from "@/utils/documentTitle"

/** Syncs `document.title` from the inset breadcrumb trail (route + dynamic overrides). */
export function useDocumentTitle(): void {
  const { pathname, search } = useLocation()
  const { trailOverride } = useShadcnInsetBreadcrumbContext()

  useEffect(() => {
    const trail =
      trailOverride ??
      getBreadcrumbTrail(routes as RouteConfigArray, pathname, search)
    document.title = resolveDocumentTitle(pathname, trail)
  }, [pathname, search, trailOverride])
}
